import { render, staticRenderFns } from "./grantDetails.vue?vue&type=template&id=8a837bca&scoped=true"
import script from "./grantDetails.vue?vue&type=script&lang=js"
export * from "./grantDetails.vue?vue&type=script&lang=js"
import style0 from "./grantDetails.vue?vue&type=style&index=0&id=8a837bca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a837bca",
  null
  
)

export default component.exports